
import React from 'react';
import { useSelector } from 'react-redux';

import {
    getUsekMezAttributes,
    getUsekMezItems,
} from '../../reducers/project';

import { PAGE_PRICELIST, PAGE_USEK_INPUT, redirectToPage } from '../pagesDefinition';
import UsekAttrsPageView from './UsekAttrsPage.view';
import UsekAttributes from './UsekAttributes.state';
import UsekAttributesValidator from './UsekAttributesValidator.view';
import UsekSelector from './UsekSelector.state';

const UsekAttrsPageState = () => {

    const [usekId, setUsekId] = React.useState(null);

    const usekMezAttributes = useSelector(state => getUsekMezAttributes(state.project));
    const usekMezItems = useSelector(state => getUsekMezItems(state.project));

    React.useEffect(() => {
        if (!usekMezItems || (usekMezItems.length === 0)) {
            redirectToPage(PAGE_USEK_INPUT);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    React.useEffect(() => {
        if(!usekId && usekMezItems && (usekMezItems.length > 0)) {
            setUsekId(usekMezItems[0].properties.id_usek);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [usekMezItems]);

    const getCanContinue = () => {
        let isValid = false;
        if (usekMezItems && usekMezItems.length > 0) {
            isValid = (getInvalidUsekItems().length === 0);
        }
        return isValid;
    }

    const getInvalidUsekItems = () => {
        let invalidUsekItems = [];
        if (usekMezItems && usekMezItems.length > 0) {
            usekMezItems.forEach(item => {
                let isValid = true;
                let attrs = usekMezAttributes[item.properties.id_usek];
                if (attrs) {
                    isValid = isValid &&
                        attrs.sirka && attrs.vyska_horni && attrs.vyska_spodni;
                    if (isValid) {
                        if (
                            (attrs.typ_uprav_vegetace === 'MV02') ||
                            (attrs.typ_uprav_vegetace === 'MV03')
                        ) {
                            isValid = isValid && attrs.rozestup;
                        }
                    }
                } else {
                    isValid = false;
                }
                if (!isValid) {
                    invalidUsekItems.push(item.properties.id_usek)
                }
            });

        }
        return invalidUsekItems;
    }

    const handleContinueClick = () => {
        redirectToPage(PAGE_PRICELIST);
    }

    const handleGoBackClick = () => {
        redirectToPage(PAGE_USEK_INPUT);
    }

    const handleUsekChange = (selectedUsekId) => {
        setUsekId(selectedUsekId);
    }

    const renderUsekAttributes = () => {
        return (
            <UsekAttributes
                usekId={usekId}
            />
        );
    }

    const renderUsekSelector = () => {
        return (
            <UsekSelector
                onChange={handleUsekChange}
                usekId={usekId}
            />
        );
    }

    const renderValidator = () => {
        return (
            <UsekAttributesValidator
                invalidUsekItems={getInvalidUsekItems()}
            />
        );
    }

    return (
        <>
            <UsekAttrsPageView
                canContinue={getCanContinue()}
                onGoBackClick={handleGoBackClick}
                onGoNextClick={handleContinueClick}
                usekAttributes={renderUsekAttributes()}
                validator={renderValidator()}
                usekSelector={renderUsekSelector()}
            />
        </>
    )
}

export default UsekAttrsPageState;
